var map = {
	"./amadeus/MasterDetail.json": 1159,
	"./barclays/MasterDetail.json": 1160,
	"./cb911/MasterDetail.json": 1161,
	"./choiceHotels/MasterDetail.json": 1162,
	"./globex/MasterDetail.json": 1163,
	"./kraken/MasterDetail.json": 1164,
	"./lastminute/MasterDetail.json": 1165,
	"./monavate/MasterDetail.json": 1166,
	"./outpayce/MasterDetail.json": 1167,
	"./sofi/MasterDetail.json": 1168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1158;